<nz-form-item>
  <nz-form-label nzFor="organization">{{ label }}</nz-form-label>
  <nz-form-control>
    <nz-select
      nzShowSearch
      [nzPlacement]="'bottomLeft'"
      [nzPlaceHolder]="placeholder"
      [nzDisabled]="disabled"
      [nzAllowClear]="false"
      name="organization"
      [(ngModel)]="defaultSelectedOrg"
      (nzOnSearch)="onSearch($event)"
      (ngModelChange)="onChange($event)">
      <nz-option [nzValue]="0" nzLabel="All" *ngIf="isNullable"></nz-option>
      <nz-option
        *ngFor="let org of orgList"
        [nzLabel]="org.value"
        [nzValue]="org.id"></nz-option>
    </nz-select>
  </nz-form-control>
</nz-form-item>
